// Base path that Vite injects, e.g. "/pwa_local/" in dev or "/pwa_current/" in prod
const RAW_BASE = import.meta.env.BASE_URL || "/";
const BASE = RAW_BASE.replace(/\/+$/, ""); // no trailing slash

export function stripBase(pathname: string = window.location.pathname): string {
  return pathname.startsWith(BASE) ? pathname.slice(BASE.length) : pathname;
}

/** Returns the tenant key from the current (or given) path, e.g. "digicall". */
export function getTenantFromPath(pathname: string = window.location.pathname): string | null {
  const seg = stripBase(pathname).replace(/^\/+/, "").split("/")[0];
  return seg || null;
}

/** Back-compat alias. */
export const tenantKeyFrom = getTenantFromPath;

/** Returns the full base path for the current tenant, e.g. "/pwa_local/digicall". */
export function tenantBaseFrom(pathname: string = window.location.pathname): string {
  const t = getTenantFromPath(pathname);
  return t ? `${BASE}/${t}`.replace(/\/\/+/g, "/") : (BASE || "/");
}

// Kept because other files might reference them
export const firstSeg = (p: string) => p.replace(/^\/+/, "").split("/")[0] || "";
export const isTenantSeg = (s: string) => /^[a-z0-9-]+$/i.test(s);
